export default {
  serverURI: window.location.hostname !== 'localhost' ?
    'https://' + window.location.hostname.replace('admin.', 'api.') :
    'http://localhost:9090'
}

